'use client';

import { c as _c } from "react/compiler-runtime";
import { useMediaQueryBelow } from '@svs/ui/media-query/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { statusTexts } from './configs/default.js';
import { getStatusText } from './getStatusText.js';
import { getIsFinished, getIsOngoing } from './utils.js';
function statusTextsShortToFull(matchStatus, isSmall) {
  switch (matchStatus) {
    case statusTexts.Cancelled.short:
      return statusTexts.Cancelled.full;
    case statusTexts.Postponed.short:
      return isSmall ? statusTexts.Postponed.short : statusTexts.Postponed.full;
    default:
      return matchStatus;
  }
}
/**
 * Hook to get the match status information for a sport event.
 *
 * @param root0 - parameters object
 * @param root0.eventStatus status for current event
 * @param root0.sportType type of sport for draw
 * @param root0.matchStart match start date time
 * @param root0.statusTime status time date time
 * @param root0.matchResultState match result state for the event, e.g. "NotStarted", "Live", "Finished"
 * @returns match status information
 */
export function useGetMatchStatus(t0) {
  const $ = _c(27);
  const {
    eventStatus,
    sportType,
    matchStart,
    statusTime,
    matchResultState
  } = t0;
  const isSmall = useMediaQueryBelow("sm");
  let t1;
  if ($[0] !== eventStatus || $[1] !== isSmall || $[2] !== matchStart || $[3] !== sportType || $[4] !== statusTime) {
    t1 = () => statusTextsShortToFull(getStatusText({
      sportEventStatus: eventStatus,
      sportType,
      matchStart,
      statusTime,
      statusTextLength: "short"
    }).matchStatusText, isSmall);
    $[0] = eventStatus;
    $[1] = isSmall;
    $[2] = matchStart;
    $[3] = sportType;
    $[4] = statusTime;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const [matchStatusText, setMatchStatusText] = useState(t1);
  let t2;
  if ($[6] !== eventStatus || $[7] !== matchResultState) {
    t2 = matchResultState ? matchResultState === "Finished" : getIsFinished(eventStatus);
    $[6] = eventStatus;
    $[7] = matchResultState;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const isFinished = t2;
  let t3;
  if ($[9] !== eventStatus || $[10] !== isFinished) {
    t3 = isFinished ? false : getIsOngoing(eventStatus);
    $[9] = eventStatus;
    $[10] = isFinished;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const isOngoing = t3;
  const stopIntervalFunctionRef = useRef(undefined);
  let t4;
  if ($[12] !== eventStatus || $[13] !== isFinished || $[14] !== isOngoing || $[15] !== matchStart || $[16] !== sportType || $[17] !== statusTime) {
    t4 = () => {
      if (isFinished) {
        setMatchStatusText("FT");
        return;
      }
      setMatchStatusText(statusTextsShortToFull(getStatusText({
        sportEventStatus: eventStatus,
        sportType,
        matchStart,
        statusTime,
        statusTextLength: "short"
      }).matchStatusText));
      if (!isOngoing) {
        return;
      }
      stopIntervalFunctionRef.current = setInterval(() => {
        setMatchStatusText(statusTextsShortToFull(getStatusText({
          sportEventStatus: eventStatus,
          sportType,
          matchStart,
          statusTime,
          statusTextLength: "short"
        }).matchStatusText));
      }, 1000);
    };
    $[12] = eventStatus;
    $[13] = isFinished;
    $[14] = isOngoing;
    $[15] = matchStart;
    $[16] = sportType;
    $[17] = statusTime;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const startTimer = t4;
  let t5;
  if ($[19] !== startTimer) {
    t5 = () => {
      if (document.hidden) {
        return;
      }
      if (stopIntervalFunctionRef.current) {
        clearInterval(stopIntervalFunctionRef.current);
        startTimer();
      }
    };
    $[19] = startTimer;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const handleVisibilityChange = t5;
  let t6;
  let t7;
  if ($[21] !== handleVisibilityChange) {
    t6 = () => {
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    };
    t7 = [handleVisibilityChange];
    $[21] = handleVisibilityChange;
    $[22] = t6;
    $[23] = t7;
  } else {
    t6 = $[22];
    t7 = $[23];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[24] !== startTimer) {
    t8 = () => {
      startTimer();
      return () => {
        if (stopIntervalFunctionRef.current) {
          clearInterval(stopIntervalFunctionRef.current);
        }
      };
    };
    t9 = [startTimer];
    $[24] = startTimer;
    $[25] = t8;
    $[26] = t9;
  } else {
    t8 = $[25];
    t9 = $[26];
  }
  useEffect(t8, t9);
  return matchStatusText;
}